import { useCallback } from "react";
import { useSnackbar } from "notistack";
import useAjax from "@apis/useAjax";
import {
	POST_MEMBER_PROFILE_PAYMENTS_CREDIT_CARD_API,
	POST_MEMBER_PROFILE_PAYMENTS_BANK_API,
	GET_MEMBER_PAYMENTS_OPTIONS_API,
	GET_MEMBER_PAYMENT_API,
	GET_MEMBER_PAYMENT_HISTORY_API,
	POST_MEMBER_PAYMENT_PLUGIN_API,
	GET_MEMBER_DOC_PAYMENT_PLUGIN_API,
	GET_MEMBER_DOC_PAYMENT_CONTRACT_API,
	GET_MEMBER_DEFAULT_CREDIT_CARD_API,
} from "@apis/apiPath";
import { isEmpty } from "@util/utils";

export const useMemberPaymentApi = () => {
	const Ajax = useAjax();
	const { enqueueSnackbar } = useSnackbar();

	// 更新信用卡付款資訊
	const postMemberPaymentCreditCardApi = useCallback(
		async (memberID, parameters) => {
			let resp = await Ajax.post(POST_MEMBER_PROFILE_PAYMENTS_CREDIT_CARD_API(memberID), parameters);

			if (!isEmpty(resp) && resp.isError && typeof resp.result === "string") return null;
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 更新ACH銀行付款資訊
	const postMemberPaymentBankAccountApi = useCallback(
		async (memberID, parameters) => {
			let resp = await Ajax.post(POST_MEMBER_PROFILE_PAYMENTS_BANK_API(memberID), parameters);

			if (!isEmpty(resp) && resp.isError && typeof resp.result === "string") return null;
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 取得會員付款方式選項
	const getMemberPaymentOptionsApi = useCallback(
		async memberID => {
			return await Ajax.get(GET_MEMBER_PAYMENTS_OPTIONS_API(memberID));
		},
		// eslint-disable-next-line
		[]
	);

	const getMemberDefaultCreditCardApi = useCallback(
		async memberID => {
			const resp = await Ajax.get(GET_MEMBER_DEFAULT_CREDIT_CARD_API(memberID));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 取得會員付款
	const getMemberPaymentApi = useCallback(
		async params => {
			return await Ajax.get(GET_MEMBER_PAYMENT_API(params.memberID, params.paymentID));
		},
		// eslint-disable-next-line
		[]
	);

	// 取得會員付款歷史
	const getMemberPaymentHistoryApi = useCallback(
		async (params = {}) => {
			return await Ajax.get(GET_MEMBER_PAYMENT_HISTORY_API(params.memberID, params.paymentID));
		},
		// eslint-disable-next-line
		[]
	);

	// 上傳付款授權書(如信用卡)
	const postMemberPaymentPluginApi = useCallback(
		async (params, formData) => {
			const resp = await Ajax.post(POST_MEMBER_PAYMENT_PLUGIN_API(params.memberID, params.paymentID), formData, {
				headerOption: {
					contentType: false,
					processData: false,
				},
			});
			if (!resp) enqueueSnackbar("付款授權書上傳失敗,請再操作一次", { variant: "error" });
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 取得會員付款附件
	const getMemberDocPaymentPluginApi = useCallback(
		async params => {
			return await Ajax.get(GET_MEMBER_DOC_PAYMENT_PLUGIN_API(params.memberID, params.paymentID, params.extension));
		},
		// eslint-disable-next-line
		[]
	);

	// 取得會員付款變更書
	const getMemberDocPaymentContractApi = useCallback(
		async params => {
			return await Ajax.get(GET_MEMBER_DOC_PAYMENT_CONTRACT_API(params.memberID, params.paymentID));
		},
		// eslint-disable-next-line
		[]
	);

	return {
		postMemberPaymentCreditCardApi,
		postMemberPaymentBankAccountApi,
		getMemberPaymentOptionsApi,
		getMemberDefaultCreditCardApi,
		getMemberPaymentApi,
		getMemberPaymentHistoryApi,
		postMemberPaymentPluginApi,
		getMemberDocPaymentPluginApi,
		getMemberDocPaymentContractApi,
	};
};
